const INSTRUMENTATION_NAME = '@sentry/instrumentation-http';

/** We only want to capture request bodies up to 1mb. */
const MAX_BODY_BYTE_LENGTH = 1024 * 1024;

export { INSTRUMENTATION_NAME, MAX_BODY_BYTE_LENGTH };
//# sourceMappingURL=constants.js.map
